
import {Vue, Component, Prop} from 'vue-property-decorator';
import {deleteDistribution, queryDistributionList, updateDistributionList} from "@/api/purchase-order";
import Template from "@/views/system-management/template/index.vue";

@Component({name: 'purchaseOrderFee',
  components: {Template}
})
export default class extends Vue {
  @Prop({ default: "" }) private hqPackingListId: "";
  @Prop({ default: true }) private canPurchaseOrderFee: boolean;
  @Prop({ default: "" }) private status: "";

  private distributionList = [];
  private codeGroupDistributionList = [];

  private table =  {
    loading: false,
    list: [],
    tableCol: [
      {
        label: "采购订单号",
        prop: "purchaseOrderCode",
        key: "purchaseOrderCode",
        show: true,
        disabled: false,
      },
      {
        label: "费用名称",
        prop: "name",
        key: "name",
        show: true,
        disabled: false,
      },
      {
        label: "本次分配金额",
        prop: "thisDistributionAmount",
        key: "thisDistributionAmount",
        show: true,
        disabled: false,
      },
      {
        label: "待分配",
        prop: "toDistributionAmount",
        key: "toDistributionAmount",
        show: true,
        disabled: false,
      },
      {
        label: "总费用",
        prop: "amount",
        key: "amount",
        show: true,
        disabled: false,
      },
      {
        label: "操作",
        prop: "action",
        type: "icon_delete",
        icon: "el-icon-delete",
        click: "handleDelete",
        show: true,
        disabled: false,
      },
    ],
    tableCol1: [
      {
        label: "采购订单号",
        prop: "purchaseOrderCode",
        key: "purchaseOrderCode",
        show: true,
        disabled: false,
      },
      {
        label: "费用名称",
        prop: "name",
        key: "name",
        show: true,
        disabled: false,
      },
      {
        label: "本次分配金额",
        prop: "thisDistributionAmount",
        key: "thisDistributionAmount",
        show: true,
        disabled: false,
      },
      {
        label: "待分配",
        prop: "toDistributionAmount",
        key: "toDistributionAmount",
        show: true,
        disabled: false,
      },
      {
        label: "总费用",
        prop: "amount",
        key: "amount",
        show: true,
        disabled: false,
      },
    ],
  };
  private addVisible = false;
  private distributionTable = {
    loading: false,
    tableCol: [
      {
        label: "名称",
        prop: "name",
        key: "name",
        show: true,
        disabled: false,
      },
      {
        label: "总费用",
        prop: "amount",
        key: "amount",
        show: true,
        disabled: false,
      },
      {
        label: "已分配",
        prop: "distributionAmount",
        key: "distributionAmount",
        show: true,
        disabled: false,
      },
      {
        label: "待分配",
        prop: "toDistributionAmount",
        key: "toDistributionAmount",
        show: true,
        disabled: false,
      },
      {
        label: "本次分配",
        prop: "thisDistributionAmount",
        key: "thisDistributionAmount",
        show: true,
        disabled: false,
        type: "inputNumber",
        precision: 2,
        maxProp: "maxAmount",
        minProp: "minAmount",
      },
    ],
  }

  created() {
    this.getDistributionList()
  }

  private async getDistributionList() {
    try {
      this.table.loading = true;
      const res = await queryDistributionList({hqPackingListId: this.hqPackingListId}) as any;
      this.distributionList = res.filter(item => item.thisDistributionAmount !== 0);
      const map = new Map();
      res.forEach(item => {
        const key = item.purchaseOrderId;
        if (!map.has(key)) {
          map.set(key, { 'id': key, 'code': item.purchaseOrderCode, list: [] });
        }
        const data = { ...item };
        if (data.amount > 0) {
          data.maxAmount = Number(data.amount);
          data.minAmount = 0;
        } else {
          data.maxAmount = 0;
          data.minAmount = Number(data.amount);
        }
        map.get(key).list.push(data);
      })
      this.codeGroupDistributionList = Array.from(map.values())
    } catch (error) {
      this.$message.error(error);
    } finally {
      this.table.loading = false;
    }
  }

  private handleAdd() {
    this.addVisible = true;
  }

  private async handleDelete(scope) {
    try {
      this.table.loading = true;
      const params = {
        hqPackingListId: this.hqPackingListId,
        purchaseOrderFeeId: scope.row.id,
      }
      await deleteDistribution(params)
      this.$message({
        message: '删除成功',
        type: 'success'
      });
      await this.getDistributionList();
    } catch (error) {
      console.log(error);
    } finally {
      this.table.loading = false;
    }
  }

  private inputChange({ row }) {
    const rowData = row.row;
    rowData.toDistributionAmount = rowData.amount - rowData.distributionAmount - rowData.thisDistributionAmount;
  }

  private async handleUpdate() {
    const list = [];
    this.codeGroupDistributionList.forEach(item => {
      item.list.forEach(i => {
        if (i.thisDistributionAmount !== 0) {
          const data = {
            purchaseOrderId: i.purchaseOrderId,
            hqPackingListId: this.hqPackingListId,
            purchaseOrderFeeId: i.id,
            amount: i.thisDistributionAmount,
          }
          list.push(data);
        }
      })
    })
    await updateDistributionList({
      hqPackingListId: this.hqPackingListId,
      req: list
    })
    this.$message({
      message: '添加成功',
      type: 'success'
    });
    this.addVisible = false;
    await this.getDistributionList();
  }

  private addDialogClose() {
    this.addVisible = false;
  }
}
